import React, { cloneElement, Children, useState, useMemo, useCallback, useRef, useEffect } from 'react';
import classNames from 'classnames';
import useOutsideClick from 'shared/lib/useOutsideClick';
import Copywriter from "shared/components/copywriter/App";
import useOutsideScroll from 'shared/lib/useOutsideScroll';

import List from './prompts/List';

const Prompts = (props) => {

  const { children, content } = props;
  const [prompt, setPrompt] = useState(null);
  const [open, setOpen] = useState(false);
  const [promptListPosition, setPromptListPosition] = useState({ top: 0, left: 0 });
  const buttonRef = useRef(null);

  const button_children = Children.map(children, (child, index) => cloneElement(child).props.children);

  const updatePosition = () => {
    if (buttonRef.current) {
      const buttonRect = buttonRef.current.getBoundingClientRect();
      setPromptListPosition({
        top: buttonRect.bottom + window.scrollY,
        left: buttonRect.left + window.scrollX,
      });
    }
  };

  useEffect(() => {
    if (open) {
      updatePosition();
    }
  }, [open]);

  const onClick = () => { setOpen(true) };

  const onClose = () => { setOpen(false) };

  const handleSelect = (value) => {
    onClose();
    setPrompt(value);
  }

  const renderMenu = () => {
    const ref = useOutsideClick(() => setOpen(false));
    const ref2 = useOutsideScroll(() => setOpen(false));

    const handleRef = (node) => {
      ref.current = node;
      ref2.current = node;
    };

    return <List forwardRef={handleRef} onSelect={handleSelect} subMenuPosition={promptListPosition} />;
  }

  const renderButton = () => {
    return <>
      {button_children}
      {open && renderMenu()}
    </>;
  }

  const className = classNames(children.props.className,
    's-prompts s-prompts_primary-button',
    {
      's-prompts--open': open,
      'active': open
    }
  );

  const onChange = useCallback((value) => {
    props.onChange(value);
    setPrompt(null);
  }, [content]);

  const onCancel = useCallback(() => {
    setPrompt(null);
  }, [content]);

  const contextProps = useMemo(() => ({
    prompt,
    content,
    onChange,
    onCancel,
  }), [prompt, content, onChange, onCancel]);

  const Button = React.forwardRef((props, ref) => cloneElement(children, { onClick, className, ref }, renderButton()));

  return (<>
    <Button ref={buttonRef} />
    {prompt && <Copywriter {...contextProps} />}
  </>);
};

export default Prompts;
